<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="dabef9d1bfb79-d1e251"><span id="pageii">
<h3 class="books-by-head"><em class="italic ">Recent Titles by Glenis Wilson</em></h3>
<p class="books-by-text">BLOOD ON THE TURF</p>
<p class="books-by-text">PHOTO FINISH</p>
<p class="books-by-text">WEB OF EVASION</p>
<p class="books-by-text">LOVE IN LAGANAS</p>
<p class="books-by-text">THE HONEY TREE</p>
<p class="books-by-text">ANGEL HARVEST</p>
<p class="books-by-text-space-after">VENDETTA </p>
<h4 class="books-by-subtitle"><em class="italic ">The Harry Radcliffe series</em></h4>
<p class="books-by-text-space-after">DEAD CERTAINTY *</p>
<p class="books-by-text">* <em class="italic ">available from Severn House</em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106403_epub_alb.vue?047fd534